/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Completed_SuccessfullyInputs */

const en_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work import completed successfully`)
};

const fr_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du travail terminée avec succès`)
};

const de_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsimport erfolgreich abgeschlossen`)
};

const it_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del lavoro completata con successo`)
};

const ru_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт работы успешно завершен.`)
};

const es_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de trabajo completada con éxito`)
};

const zh_cn2_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作导入已成功完成`)
};

const ja_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業のインポートが正常に完了しました`)
};

const hi_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य आयात सफलतापूर्वक पूरा हुआ`)
};

const pt_pt2_work_order_import_completed_successfully = /** @type {(inputs: Work_Order_Import_Completed_SuccessfullyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de trabalho concluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Work import completed successfully" |
*
* @param {Work_Order_Import_Completed_SuccessfullyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_completed_successfully = /** @type {((inputs?: Work_Order_Import_Completed_SuccessfullyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Completed_SuccessfullyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_completed_successfully(inputs)
	if (locale === "de") return de_work_order_import_completed_successfully(inputs)
	if (locale === "it") return it_work_order_import_completed_successfully(inputs)
	if (locale === "ru") return ru_work_order_import_completed_successfully(inputs)
	if (locale === "es") return es_work_order_import_completed_successfully(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_completed_successfully(inputs)
	if (locale === "ja") return ja_work_order_import_completed_successfully(inputs)
	if (locale === "hi") return hi_work_order_import_completed_successfully(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_completed_successfully(inputs)
	return en_work_order_import_completed_successfully(inputs)
});